import ConditionalFallbackPolicyModelFactory, { GlobalAuthPolicyConsts } from 'client/store/modules/models/ConditionalFallbackPolicyModelFactory';

export default ConditionalFallbackPolicyModelFactory(
  GlobalAuthPolicyConsts.userPortal,
);
